module.exports = __webpack_public_path__ + "img/icon_plus_green.f28fd21a.svg";